import { render, staticRenderFns } from "./ReleasesPg.vue?vue&type=template&id=559ac39e&scoped=true&"
import script from "./ReleasesPg.vue?vue&type=script&lang=js&"
export * from "./ReleasesPg.vue?vue&type=script&lang=js&"
import style0 from "./ReleasesPg.vue?vue&type=style&index=0&id=559ac39e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559ac39e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
